import { convertImperialToGivenUnitSystem } from '../../utilities/HelperFunctions/HelperFunctions';
import actions from '../actionTypes';
import {
  HP_MOSAIC_IMAGE_SOURCE,
  INSTAGRAM_IMAGE_SOURCE,
  SOLID_FILL_KEY,
  TEXT_ELEMENT_TYPE,
  USER_PHOTO_TYPE
} from '../../utilities/constants/Constants';
import { getPlacings } from '../ProjectData/Project';
import {
  changeObjectBorderColor,
  updatePlacingCoords
} from '../fabricCanvasActions';

export const doesProjectHasPixelatedImage = project => dispatch => {
  const placings = getPlacings(project);
  for (let i = 0; i < placings.length; i++) {
    const placing = placings[i];
    if (dispatch(isPixelatedObject(placing))) {
      return true;
    }
  }
  return false;
};

export const checkForPixelationWarning = element => dispatch => {
  if (element && Object.prototype.hasOwnProperty.call(element, 'placing')) {
    const isPixelated = dispatch(isPixelatedObject(element.placing));
    if (isPixelated) {
      const pixels = dispatch(validImageDimensionsInPixels(element.placing));
      dispatch({
        type: actions.UPDATE_NON_PIXELATED_DIMENION,
        payload: { value: pixels }
      });
    }
    return isPixelated;
  }
  return false;
};

export const isPixelatedObject = placing => (dispatch, getState) => {
  if (placing.placeable) {
    if (
      placing.placeableType === SOLID_FILL_KEY ||
      (placing.placeableType == USER_PHOTO_TYPE &&
        (placing.placeable.imageSource == INSTAGRAM_IMAGE_SOURCE ||
          placing.placeable.imageSource == HP_MOSAIC_IMAGE_SOURCE))
    ) {
      return false;
    }
    if (
      placing.placeable.printableImageHeight <= 0 ||
      placing.placeable.printableImageWidth <= 0
    ) {
      return false;
    }

    if (getState().modal.storeData.warnOnBackgroundScale) {
      const projectDpi = dispatch(getProjectDpi(placing));
      const expectedDpi = dispatch(getExpectedDpi());
      return projectDpi <= expectedDpi;
    }
  }
  return false;
};

export const validImageDimensionsInPixels = placing => (dispatch, getState) => {
  const upscaleMaxPixelDimension = getState().modal.envData
    .upscale_max_pixel_dimension;

  const upscale = dispatch(upScaleFactor(placing.placeable));
  const expectedDpi = dispatch(getExpectedDpi());

  const printableWidth = placing.placeable.printableImageWidth;
  const printableHeight = placing.placeable.printableImageHeight;

  const imageRatio = printableHeight / printableWidth;
  const heightDpi = upscale.height / placing.height;
  const widthDpi = upscale.width / placing.width;

  let upscaledWidth = Math.ceil(expectedDpi * placing.width);
  let upscaledHeight = Math.ceil(imageRatio * upscaledWidth);

  if (heightDpi < widthDpi) {
    upscaledHeight = Math.ceil(expectedDpi * placing.height);
    upscaledWidth = Math.ceil(upscaledHeight / imageRatio);
  }

  if (
    !(
      upscaledWidth > upscaleMaxPixelDimension ||
      upscaledHeight > upscaleMaxPixelDimension
    )
  ) {
    upscaledWidth = Math.ceil(upscaledWidth / upscale.upscaleFactor);
    upscaledHeight = Math.ceil(upscaledHeight / upscale.upscaleFactor);
  }
  return {
    width: upscaledWidth,
    height: upscaledHeight
  };
};

export const getProjectDpi = placing => dispatch => {
  const upScale = dispatch(upScaleFactor(placing.placeable));
  const dpi = Math.min(
    upScale.height / placing.height,
    upScale.width / placing.width
  );
  return dpi;
};

export const getExpectedDpi = () => (dispatch, getState) => {
  let { defaultViewingDistance } = getState().modal.storeData;
  const distance = getState().finalCheck.project.targetViewingDistance;

  if (distance !== null) {
    defaultViewingDistance = distance;
  }
  const dpiWarning = (3438 * 1.5) / defaultViewingDistance;
  return dpiWarning;
};

export const currentDisplayDpi = element => dispatch => {
  const projectDpi = dispatch(getProjectDpi(element.placing));
  let number = projectDpi.toString(); // If it's not already a String
  number = Number(number.slice(0, number.indexOf('.'))); // Without exposing the decimal place
  return number;
};

export const upScaleFactor = placeable => (dispatch, getState) => {
  const printableWidth = placeable.printableImageWidth;
  const printableHeight = placeable.printableImageHeight;
  const upscaleMaxPixelDimension = getState().modal.envData
    .upscale_max_pixel_dimension;
  const upscaleFactor = getState().modal.envData.upscale_factor;

  const upScale = upscaledDimensions(
    printableWidth,
    printableHeight,
    upscaleMaxPixelDimension,
    upscaleFactor
  );

  return upScale;
};

export const upscaledDimensions = (
  width,
  height,
  upscaleMaxPixelDimension,
  upscaleFactor
) => {
  const returnHash = {};
  let newUpscaleFactor = upscaleFactor;
  if (width > upscaleMaxPixelDimension || height > upscaleMaxPixelDimension) {
    newUpscaleFactor = 1;
  } else if (
    width * upscaleFactor > upscaleMaxPixelDimension ||
    height * upscaleFactor > upscaleMaxPixelDimension
  ) {
    if (width > height) {
      newUpscaleFactor = upscaleMaxPixelDimension / width;
    } else {
      newUpscaleFactor = upscaleMaxPixelDimension / height;
    }
  }

  returnHash.width = width * newUpscaleFactor;
  returnHash.height = height * newUpscaleFactor;
  returnHash.upscaleFactor = newUpscaleFactor;
  return returnHash;
};

export const minimumViewingDistanceForWarningRemovalInCurrentUnitSystem = element => (
  dispatch,
  getState
) => {
  let minimumViewDistance = 0;
  const { unitSystem } = getState().home;
  const projectDpi = dispatch(getProjectDpi(element.placing));
  minimumViewDistance = (3438 * 1.5) / projectDpi + 1;
  minimumViewDistance = convertImperialToGivenUnitSystem(
    minimumViewDistance,
    unitSystem
  );
  return minimumViewDistance;
};

export const setShowPixelationWindowDialogue = value => (
  dispatch,
  getState
) => {
  dispatch({
    type: actions.SHOW_PIXELATION_WINDOW_DIALOGUE,
    payload: {
      showPixelationWindowDialogue: value
    }
  });
  if (value && !getState().fabricCanvas.setInitialPixelationShown) {
    dispatch({
      type: actions.SET_INITIAL_PIXELATION_DIALOG_SHOWN
    });
  }
};

export const checkObjectForPixelation = object => dispatch => {
  dispatch(updatePlacingCoords(object));
  if (
    Object.prototype.hasOwnProperty.call(object, 'placing') &&
    object.placing.placeableType !== TEXT_ELEMENT_TYPE
  ) {
    const warning = dispatch(checkForPixelationWarning(object));
    object.hasPixelationWarning = warning;
    changeObjectBorderColor(object, dispatch);
  }
};
